
{
  "label": "Theme",
  "options": {
    "light": "Light",
    "dark": "Dark"
  }
}
